import * as R from 'ramda';

export const Record = defaultValue => R.compose(R.merge(defaultValue), R.pick(R.keys(defaultValue)));
